// import { RootStore } from 'mobx-stores'
import { PaginationSearchBase, TriggerSearchFunc } from 'mobx-stores/utils'
import { Api } from 'services'
import {
  DepartmentsTableSearchProps,
  DepartmentsTableSortProps
} from './departments-table-store.types'
import {
  initialDepartmentsTablePaginationProps,
  initialDepartmentsTableSearchProps,
  departmentsTableNeedTimeoutSearchProps
} from './departments-table-store.utils'
import { DepartmentsFilterDTO } from 'models/departments-filter'
import { DepartmentsTableEntityDTO } from 'models/departments-table-entity'

export class DepartmentsTableStore extends PaginationSearchBase<
  DepartmentsTableSortProps,
  DepartmentsTableSearchProps,
  DepartmentsTableEntityDTO
> {
  private departmentsApi: Api['departmentsApi']

  constructor (rootStore: any) {
    super({
      initialPaginationProps: initialDepartmentsTablePaginationProps,
      initialSearchProps: initialDepartmentsTableSearchProps,
      needTimeoutProps: departmentsTableNeedTimeoutSearchProps
    })
    this.departmentsApi = rootStore.generalStore.api.departmentsApi
  }

  // METHODS
  public triggerSearch: TriggerSearchFunc = async (options): Promise<void> => {
    const data = await this.departmentsApi.allFilteredSorted(this.storeFilter, {
      pageQueryParams: {
        page: options?.resetPageNumber ? 0 : this.pagination.page,
        size: this.pagination.size,
        sortDirection: this.pagination.sortDirection,
        sortProp: this.pagination.sortProp
      }
    })
    if (!data) return
    this.handleSearchResultPaginationProps(data)
    this.setSearchResults(data.content)
  }

  // COMPUTED
  private get storeFilter (): DepartmentsFilterDTO {
    return {
      name: this.searchProps.name
    }
  }
}
